<template>
  <TaskPage class="container-lg" no-brand no-back :no-action="isSentRef" :can-continue="isValidRef && !busyRef" @action="onSubmitTicket">
    <template #title>
      <img class="title-icon" src="@webapp/assets/icons/mail_gray_60.png"/>
      Contact us
    </template>
    <ContactForm ref="formRef" v-model:is-valid="isValidRef"/>
    <template #actionText>
      <template v-if="busyRef">
        <Spinner/>
        Sending...
      </template>
      <template v-else>
        Send
      </template>
    </template>
  </TaskPage>
</template>

<style lang="scss" scoped>
.title-icon {
  margin-right: 0.5rem;
  transform: translateY(-2px);
  width: 3rem;
  filter: brightness(0) saturate(100%) invert(63%) sepia(76%) saturate(5097%) hue-rotate(184deg) brightness(100%) contrast(94%);
}
</style>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { usePageTitle } from '@webapp/util/AppUtil'
import TaskPage from '@webapp/util/TaskPage.vue'
import Spinner from '@webapp/util/Spinner.vue'
import ContactForm from './ContactForm.vue'

const isValidRef = ref(false)
const busyRef = ref(false)
const isSentRef = ref(false)
const formRef = ref<InstanceType<typeof ContactForm>>()

usePageTitle("Contact us")

onMounted(() => {
  isSentRef.value = false
  formRef.value?.reset()
})

async function onSubmitTicket() {
  try {
    busyRef.value = true
    await formRef.value?.submitTicket()
    isSentRef.value = true
  } finally {
    busyRef.value = false 
  }
}
</script>
